const r = ":host{display:inline-block}.sl-label{font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);font-weight:var(--sl-font-weight-medium);line-height:1;color:hsl(var(--sl-hsl-foreground));display:inline-block;cursor:pointer}.sl-label--required::after{content:'*';color:hsl(var(--sl-hsl-destructive));margin-left:var(--sl-spacing-1)}";
class l extends HTMLElement {
  static get observedAttributes() {
    return ["for", "required"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  attributeChangedCallback(e, t, s) {
    t !== s && this._render();
  }
  get for() {
    return this.getAttribute("for");
  }
  set for(e) {
    e ? this.setAttribute("for", e) : this.removeAttribute("for");
  }
  get required() {
    return this.hasAttribute("required");
  }
  set required(e) {
    e ? this.setAttribute("required", "") : this.removeAttribute("required");
  }
  _render() {
    const e = ["sl-label"];
    this.required && e.push("sl-label--required"), this._shadow.innerHTML = `
      <style>${r}</style>
      <label
        ${this.for ? `for="${this.for}"` : ""}
        class="${e.join(" ")}"
      >
        <slot></slot>
      </label>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-label") && customElements.define("sl-label", l);
export {
  l as SlLabelElement
};
//# sourceMappingURL=sl-label.js.map
